
const Book = ({ book }) => {
  //console.log("t:"+book);
  return (
    <a
      href={`book?book_id=${encodeURIComponent(book.book_id)}`}
      className="book"
      data-book-id={encodeURIComponent(book.book_id)}
    >
      <div className="cover_title">{book.book_title}</div>
      <div className="cover_author">{book.book_author}</div>
    </a>
  );
};

export default Book;
